module.exports = __webpack_public_path__ + "static/media/arrow.6bf3189e.svg";